module.exports = __webpack_public_path__ + "static/media/toolbar-q-hideable.0fba2416.svg";